import { css, Stack, styled } from '@mui/material';

export const IconsContainer = styled(Stack)(
  ({ theme }) => css`
    position: absolute;
    top: ${theme.spacing(2)};
    right: ${theme.spacing(2)};
  `,
);
